module.exports = __webpack_public_path__ + "static/media/lockicon.5e3d8f30.svg";